import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import {
  receiveTemplateBuilder,
  updateDataTemplate,
  updateDataTemplateItem,
  updateDataTemplateItems,
  updateDetailTemplates,
} from "../actionCreators";
import { AllDataTemplates } from "../../../requests/templateBuilder/types";
import typeGuards from "../../../type-guards";

type State = AllDataTemplates | undefined;

const initialState: State = undefined;

const dataTemplateReducer = reducer(
  initialState as State,
  on(receiveTemplateBuilder, (state, action) => ({
    ...action.payload.templateBuilder.dataTemplate,
  })),
  on(updateDataTemplate, (state, action) => ({
    ...action.payload.dataTemplate,
  })),
  on(updateDataTemplateItems, (state, { payload: { items } }) => {
    if (!state) return;
    state.items = items;
  }),
  on(updateDataTemplateItem, (state, { payload: { item } }) => {
    if (!state) return;
    if (!typeGuards.forDataTemplate.hasStandardDataModel(state)) return;

    state.items[item.globalId] = {
      ...state.items[item.globalId],
      ...item,
    };
  }),
  on(updateDetailTemplates, (state, { payload: { detailTemplates } }) => {
    if (!state) return;
    if (!typeGuards.forDataTemplate.isMultiDetail(state)) return;

    state.detailTemplates = detailTemplates;
  })
);

export default dataTemplateReducer;
